import { ButtonBase, Divider, Tooltip } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import React from 'react'

import { gregorianToJalaali } from '../../../helpers/date'
import { getTranslate, lang } from '../../../localization'
import { Template } from '../../../types/contractTemplate'
import useStyles from './styles/index.styles'

interface TemplateTimeIntervalProps {
  index: number
  data: Template
  onDelete: (index: number) => void
}

const TemplateTimeInterval: React.FC<TemplateTimeIntervalProps> = ({
  index,
  onDelete,
  data
}) => {
  const classes = useStyles()
  return (
    <>
      <div className={classes.eachSeperatedRow}>
        <div className={classes.counter}>{index}</div>
        <div>
          <ButtonBase onClick={() => onDelete(index - 1)}>
            <DeleteIcon />
          </ButtonBase>
        </div>
      </div>
      <div className={classes.root}>
        <div>
          <Tooltip
            placement={lang === 'fa' ? 'right' : 'left'}
            title={
              <div>
                {lang === 'fa'
                  ? gregorianToJalaali(data.From) +
                    ' => ' +
                    gregorianToJalaali(data.To)
                  : data.From + ' => ' + data.To}
              </div>
            }>
            <div className={classes.eachSeperatedRow}>
              <div>{getTranslate('Days: ')}</div>
              {lang === 'fa'
                ? gregorianToJalaali(data.To) +
                  ' <= ' +
                  gregorianToJalaali(data.From)
                : data.From + ' => ' + data.To}
            </div>
          </Tooltip>
        </div>
        <Divider />
        {data.CurrencyDiscounts.map((cd) => (
          <div className={classes.eachSeperatedRow}>
            <div>{getTranslate('Discount: ') + cd.Currency}</div>
            {cd.DiscountPercent}%
          </div>
        ))}
        {data.Restrictions.CTA !== undefined && (
          <>
            <Divider />
            <div className={classes.eachSeperatedRow}>
              <div>{getTranslate('CTA: ')}</div>
              {data.Restrictions.CTA
                ? getTranslate('True')
                : getTranslate('False')}
            </div>
          </>
        )}
        {data.Restrictions.CTD !== undefined && (
          <>
            <Divider />
            <div className={classes.eachSeperatedRow}>
              <div>{getTranslate('CTD: ')}</div>
              {data.Restrictions.CTD
                ? getTranslate('True')
                : getTranslate('False')}
            </div>
          </>
        )}
        {!!data.Restrictions.MinStay && (
          <>
            <Divider />
            <div className={classes.eachSeperatedRow}>
              <div>{getTranslate('MinStay: ')}</div>
              {data.Restrictions.MinStay}
            </div>
          </>
        )}
        {!!data.Restrictions.MaxStay && (
          <>
            <Divider />
            <div className={classes.eachSeperatedRow}>
              <div>{getTranslate('MaxStay: ')}</div>
              {data.Restrictions.MaxStay}
            </div>
          </>
        )}
        {data.Restrictions.Status !== undefined && (
          <>
            <Divider />
            <div className={classes.eachSeperatedRow}>
              <div>{getTranslate('Status: ')}</div>
              {data.Restrictions.Status
                ? getTranslate('True')
                : getTranslate('False')}
            </div>
          </>
        )}
      </div>
    </>
  )
}

export default TemplateTimeInterval
